    document.addEventListener("DOMContentLoaded", function () {
        initSommaire();
        colorizeToolbar();
    });

    function initSommaire() {
        // Container du sommaire
        const sommaireContainer = document.getElementById("sommaire_container");
        if (!sommaireContainer) return;
        // menu déja créé en prévisualisation
        if (sommaireContainer.hasChildNodes()) return;

        // recupération des titres à cibler
        const headings = document.querySelectorAll(".page-main-content__main h2:not(.modal__title), .title_download h3");
        if (!headings.length) return;

        const ul = document.createElement("ul");
        ul.classList.add("u-list-naked", "sommaire__list");
        headings.forEach((h2, index) => {
            // Génération d’un id unique si absent
            if (!h2.id) {
                h2.id = generateUID();
            }

            const li = document.createElement("li");
            li.classList.add("sommaire__item");
            const a = document.createElement("a");
            a.classList.add("sommaire__link");

            a.textContent = h2.textContent;
            a.href = `#`+h2.id;

            // Scroll fluide
            a.addEventListener("click", function (e) {
                e.preventDefault();

                // 1) retire l'état "current" partout
                ul.querySelectorAll("li").forEach((li) => li.classList.remove("sommaire__item--current"));

                // 2) ajoute l'état "current" au titre cliqué (cible du lien)
                li.classList.add("sommaire__item--current");

                document.getElementById(h2.id).scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });

            li.appendChild(a);
            ul.appendChild(li);
        });

        sommaireContainer.appendChild(ul);

    }

    function generateUID() {
        return "sommaire-" + crypto.randomUUID()
    }

    function colorizeToolbar() {
        document.querySelectorAll('.toolbar__item button').forEach(function(button){
            if (button.classList.contains('button--accent')) {
                button.className = button.className.replace('button--accent', 'button--neutral');
            }
        });
    }